/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_Pick_GroupInputs */

const vi_shop_home_link_pick_group = /** @type {(inputs: Shop_Home_Link_Pick_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhóm sản phẩm`)
};

/**

* @param {Shop_Home_Link_Pick_GroupInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_pick_group = /** @type {((inputs?: Shop_Home_Link_Pick_GroupInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_Pick_GroupInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_pick_group(inputs)
});